import { render, staticRenderFns } from "./zone-introduce.vue?vue&type=template&id=38a5516e&scoped=true"
import script from "./zone-introduce.vue?vue&type=script&lang=js"
export * from "./zone-introduce.vue?vue&type=script&lang=js"
import style0 from "./zone-introduce.vue?vue&type=style&index=0&id=38a5516e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a5516e",
  null
  
)

export default component.exports